export class Material{

    id:number;
	nome:string;
	tipo:string;	
	nomeNotaFiscal:string;	
	codigoUnidadeMedida:string;	
	descricaoUnidadeMedida:string;	
	quantidadeLimitePedido:number;
	numeroVidaUtil:number;
	valorDepreciacao:number;

}